// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"91":"9f7dfc17","152":"3e94d04c","163":"d8b068c8","187":"5b84d3ec","259":"402277b2","306":"33b8cbff","327":"fc2be7e7","349":"238057a1","384":"f8320db1","411":"12cbdbca","434":"25abdbb5","456":"b9a2be30","764":"5f9435a1"}[chunkId] + ".chunk.js";
};